// import logo from './logo.svg';
import './App.css';
import React from 'react';
import LandSlotsWebsite from './components/LandSlotsWebsite';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import NavBar from "../src/components/Navbar";
import Footer from "../src/components/Footer";
// import LandSlotsWebsite from "../src/components/LandSlotsWebsite";
import About from "../src/components/About.jsx";
import FruitJuice from "./components/FruitJuice.jsx";
import ManagementSoft from "../src/components/ManagementSoft.jsx";
import Contact from "../src/components/Contact.jsx";
import { HelmetProvider,Helmet } from "react-helmet-async";
import UrbanFighter from './components/UrbanFighter.jsx';
import KingOfTheJungle from './components/KingOfTheJungle.jsx';
import PrivacyPolicy from './components/PrivactPolicy.jsx';
import Hardware from './components/Hardware.jsx';
import Bonuses from './components/Bonuses.jsx';
import Jackpot from './components/Jackpot.jsx';
import SlotsPage from './components/SlotsPage.jsx';

function App() {
  console.log("App component rendered");
  return (
    <HelmetProvider>
        <Helmet>
        <title>Fusion Spin: Land Slot Services, Casino Game Outsourcing</title>
        <meta
          name="description"
          content="Fusion Spin offers innovative casino slot software, land slot services, and casino game outsourcing with cutting-edge slot machines and custom solutions."
        />
        <meta
          name="keywords"
          content="Casino Slot Software, land slot services, casino game outsourcing, fusion spin, land-based casino games, custom slot machines, slot game development, casino slot services"
        />
      </Helmet>
       <Router>
      <NavBar />
      <div className="App" >
        <Routes>
          <Route path="/" element={<LandSlotsWebsite />} />
          <Route path="/about" element={<About />} />
          <Route path="/slots" element={<SlotsPage />} />
          <Route path="/urban-fighter" element={<UrbanFighter />} />
          <Route path="/fruit-juice" element={<FruitJuice/>}/>
          <Route path="/king-of-the-jungle" element={<KingOfTheJungle />} />
          <Route path="/hardware" element={<Hardware/>} />
          <Route path="/bonuses" element={<Bonuses/>} />
          <Route path="/jackpot" element={<Jackpot/>} />
          <Route path="/management-software" element={<ManagementSoft />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<Contact />} />
          
        </Routes>
        {/* <UrbanFighter /> */}
      </div>
      <Footer />
    </Router>
    </HelmetProvider>
   
  );
}



export default App;
